import request from '@/utils/request'

// 获取服务详情
export const getServiceDetail = (params) => request({
  url: '/workOnLine/employ/open/getEmployInfo',
  method: 'get',
  params
})
// 获取服务指南
export const getServiceGuide = (employId) => request({
  url: '/workOnLine/employ/open/getEmployInformation',
  method: 'get',
  params: { employId }
})
// 服务评分
export const serviceScore = (params) => request({
  url: '/workOnLine/employ/score/save',
  method: 'post',
  params
})
// 收藏服务
export const collectService = (employId) => request({
  url: '/workOnLine/employ/collectEmploy',
  method: 'post',
  params: { employId }
})